<template>
    <div class="searchInputbox flexItem bgF6F6F6"
         style="height: 36px; border-radius: 18px;line-height:30px">
        <div class="glassArea floatL" style="width: 40px; ">
            <img class="icon size12" src="components/search/grey_magnifier_icon.svg"
                 style="margin-left: 20px; margin-top: 4px;vertical-align:middle"/>
        </div>
        <div class="inputText floatL">
            <!--            <input type="text" class="font12r noBorder no_bg noOutline" style="line-height: 20px;padding-top:8px;"-->
            <!--               :placeholder="placeholder ? placeholder : ''" v-model="value"/>-->
            <el-autocomplete
                class="font12r noBorder no_bg noOutline autoCompleteInputCtrl"
                style="line-height: 20px; "
                v-model="value"
                :fetch-suggestions="querySearch"
                :placeholder="placeholder ? placeholder : ''"
                :trigger-on-focus="false"
                popperClass="autocompleteSuggestions hidden"
                @select="onSelectKeywords"
            >
                <template slot-scope="{ item }">
                    {{ item.value }}
                </template>
            </el-autocomplete>
        </div>
        <div v-show="value !== ''"  class="clearCenter fr" style="width: 38px;">
            <img class="icon" src="icon/grey_circle_close_icon.svg" title="清空关键词"
                 style="margin-top: 6px;" @click="cleanValue()"/>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import timerManager from "@comp/platformApi/timerManager";

import searchApi from "@comp/search/searchApi";
import domHelper from "@util/domHelper";

export default {
    name: "searchInputbox",
    props : {
        placeholder : {
            type : String
        }
    },
    data() {
        return {
            value: "",
            restaurants : []
        }
    },
    methods : {
        cleanValue() {
            this.value = '';
            this.$emit('change', {
                value : this.value
            });
        },
        querySearch(queryString, cb) {
            console.log('queryString: ' + queryString);

            searchApi.getSuggestions(queryString, (resultList) => {

                // clean old data
                this.restaurants = [];

                for (let i=0; i<resultList.length; i++)
                {
                    this.restaurants.push({
                        value : resultList[i]
                    });
                }

                this.$emit('suggest', resultList);
                //cb(this.restaurants);
            });
        },
        setValue(value) {
            this.value = value;
            this.$emit('change', {
                value : this.value
            });
        },
        onSelectKeywords(item) {
            this.value = item.value;
            this.$emit('change', {
                value : this.value
            });
        },
        focus() {

            let comp = domHelper.get('.autoCompleteInputCtrl');

            if (!comp)
            {
                return;
            }

            let input = domHelper.queryChild(comp, 'input');
            if (!input)
            {
                return;
            }

            if (input.offsetWidth)
            {
                domHelper.triggerFocusEvent(input);
            }
            else
            {
                timerManager.setTimeout(() => {
                    domHelper.triggerFocusEvent(input);
                }, 500);
            }

        }
    }

}
</script>

<style scoped>

</style>
